<script>

    import { mode, provetta, location, email, timestamp, pushRegistration, height, note } from '../store';
    import { Button, Icon, ProgressCircular } from 'svelte-materialify';
    import { mdiCheckBold, mdiAlertCircle } from '@mdi/js';

    export let _window;
    export let isVisible;
    export let server;

    $: isVisible, updateProvettaStatus();

    let _mode, _provetta, _location, _email, _pushRegistration, _timestamp, _height, _note;
    let result = null;

    mode.subscribe(val => _mode = val);
    provetta.subscribe(val => _provetta = val);
    location.subscribe(val => _location = val);
    pushRegistration.subscribe(val => _pushRegistration = val);
    email.subscribe(val => _email = val);
    timestamp.subscribe(val => _timestamp = val);
    height.subscribe(val => _height = val);
    note.subscribe(val => _note = val);

    function updateProvettaStatus() {
        if(_mode === "start")
            sendProvetta();
        else
            closeProvetta();
    }

    async function sendProvetta() {
        
        if(!isVisible)
            return;

        result = null;

        try {

            let p = new FormData();
            p.append("id_provetta", _provetta);
            p.append("email", _email);
            if(_note)
                p.append("note", _note);
            p.append("altitudine", _height);
            p.append("posizione", JSON.stringify(_location));
            p.append("timestamp", _timestamp.getTime());
            if(_pushRegistration)
                p.append("client_id", JSON.stringify(_pushRegistration));
            let response = await fetch(`https://${server}.sensesquare.eu:5002/apertura_provetta`, {method: "POST", body: p});
            result = await response.json();
            
        } catch (error) {
         
            result = {
                response_code: 400,
                message: "Ops! Sembra esserci un problema"
            }
            
        }
        
    }

    async function closeProvetta() {
        
        if(!isVisible)
            return;

        result = null;

        try {

            let p = new FormData();
            p.append("id_provetta", _provetta);
            p.append("timestamp", _timestamp.getTime());
            let response = await fetch(`https://${server}.sensesquare.eu:5002/chiusura_provetta`, {method: "POST", body: p});
            result = await response.json();
            
        } catch (error) {
         
            result = {
                response_code: 400,
                message: "Ops! Sembra esserci un problema"
            }
            
        }
        
    }

</script>

<main>

    <div class="container-info pa-3">

        <div class="box white rounded elevation-1 pa-3 black-text">

            {#if result === null}
            
                <ProgressCircular color="green" indeterminate />

            {:else}

                <div class="icon d-flex justify-center pt-3">

                    {#if result.response_code === 200}
                    
                        {#if _mode === "start"}

                            <img src="/media/Cup-Off.gif" alt="Apri provetta" />

                        {:else}
                        
                            <img src="/media/Cup-On.gif" alt="Chiudi provetta" />

                        {/if}

                    {:else}

                        <Button fab depressed disabled class="white elevation-3">
                            <Icon path={mdiAlertCircle} class="black-text" />
                        </Button>

                    {/if}
                    
                </div>

                <div class="text pt-6">

                    <span class="text-center">
                        {result.message}
                    </span>

                    <br>

                    {#if result.response_code === 200}

                        {#if _mode === "start"}

                            Ora puoi procedere rimuovendo il tappo dalla provetta posizionandola nel punto prescelto

                        {:else}
                        
                            Ora puoi procedere rimettendo il tappo alla provetta

                        {/if}

                    {/if}

                </div>

                <div class="action pt-6">

                    <Button rounded depressed class="green white-text" on:click={_window.next}>
                        Torna alla home
                    </Button>

                </div>

            {/if}

        </div>

    </div>

</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        transform: translate(0);
    }

    .container-info {
        position: absolute;
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
    }

    .box > div {
        width: 100%;
        display: grid;
        place-items: center;
        text-align: justify;
    }

    img {
        width: 60%;
    }

</style>